
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  import { Playground } from 'docz';
import {
  devsistersCiColorBrightOrange,
  devsistersCiColorBlack,
  devsistersCiColorCoolGray,
  devsistersCiColorWarmGray,
  cookieRunCiColorMain,
  cookieRunCiColorSub,
} from '@devsisters/ui-common';
import { DevsistersCi } from '@devsisters/ui-common';
import { CookieRunCi } from '@devsisters/ui-common';
import {
  DevsistersBranchCi,
  BranchCiJapan,
  BranchCiTaiwan,
  BranchCiMars,
  BranchCiStun,
  BranchCiConnectier,
  BranchCiVentures,
} from '@devsisters/ui-common';
import {
  JellyPopGamesCi,
  OrumlabsCi,
  RubycuveCi,
  MakersGamesCi,
} from '@devsisters/ui-common';

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}>
<MDXTag name="h1" components={components} props={{"id":"company-identity"}}>{`company identity`}</MDXTag>
<MDXTag name="h2" components={components} props={{"id":"colors"}}>{`colors`}</MDXTag>

<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-tsx"}}>{`import {
  devsistersCiColorBrightOrange, // rgb(255, 95, 0)
  devsistersCiColorBlack, // rgb(35, 34, 34)
  devsistersCiColorCoolGray, // rgb(138, 138, 141)
  devsistersCiColorWarmGray, // rgb(216, 209, 202)
  cookieRunCiColorMain, // rgb(70, 30, 6)
  cookieRunCiColorSub, // rgb(255, 215, 0)
} from '@devsisters/ui-common';
// 또는 ... from '@devsisters/ui-common/lib/common/identity';
`}</MDXTag></MDXTag>
<MDXTag name="h2" components={components} props={{"id":"devsistersci"}}>{`DevsistersCi`}</MDXTag>
<MDXTag name="p" components={components}><MDXTag name="em" components={components} parentName="p">{`데브시스터즈(주)`}</MDXTag>{`의 CI입니다.`}</MDXTag>

<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-tsx"}}>{`import { DevsistersCi } from '@devsisters/ui-common';
// 또는 import { DevsistersCi } from '@devsisters/ui-common/lib/identity';
`}</MDXTag></MDXTag>
<MDXTag name="h3" components={components} props={{"id":"놀이터"}}>{`놀이터`}</MDXTag>
<Playground __position={0} __code={'<DevsistersCi\n  style={{\n    display: \'block\',\n    fontSize: \'50px\',\n    color: devsistersCiColorBrightOrange,\n  }}\n/>\n<DevsistersCi\n  style={{\n    display: \'block\',\n    fontSize: \'50px\',\n    color: devsistersCiColorBlack,\n  }}\n/>\n<DevsistersCi\n  style={{\n    display: \'block\',\n    fontSize: \'50px\',\n    color: devsistersCiColorCoolGray,\n  }}\n/>\n<DevsistersCi\n  style={{\n    display: \'block\',\n    fontSize: \'50px\',\n    color: devsistersCiColorWarmGray,\n  }}\n/>'} __scope={{props: this ? this.props : props,devsistersCiColorBrightOrange,devsistersCiColorBlack,devsistersCiColorCoolGray,devsistersCiColorWarmGray,cookieRunCiColorMain,cookieRunCiColorSub,DevsistersCi,CookieRunCi,DevsistersBranchCi,BranchCiJapan,BranchCiTaiwan,BranchCiMars,BranchCiStun,BranchCiConnectier,BranchCiVentures,JellyPopGamesCi,OrumlabsCi,RubycuveCi,MakersGamesCi}}>
  <DevsistersCi style={{
    display: 'block',
    fontSize: '50px',
    color: devsistersCiColorBrightOrange,
  }}/>
  <DevsistersCi style={{
    display: 'block',
    fontSize: '50px',
    color: devsistersCiColorBlack,
  }}/>
  <DevsistersCi style={{
    display: 'block',
    fontSize: '50px',
    color: devsistersCiColorCoolGray,
  }}/>
  <DevsistersCi style={{
    display: 'block',
    fontSize: '50px',
    color: devsistersCiColorWarmGray,
  }}/>
</Playground>
<MDXTag name="h2" components={components} props={{"id":"cookierunci"}}>{`CookieRunCi`}</MDXTag>
<MDXTag name="p" components={components}><MDXTag name="em" components={components} parentName="p">{`(주)쿠키런`}</MDXTag>{`의 CI입니다.`}</MDXTag>

<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-tsx"}}>{`import { CookieRunCi } from '@devsisters/ui-common';
// 또는 import { CookieRunCi } from '@devsisters/ui/lib/common/identity';
`}</MDXTag></MDXTag>
<MDXTag name="h3" components={components} props={{"id":"놀이터-1"}}>{`놀이터`}</MDXTag>
<Playground __position={1} __code={'<CookieRunCi\n  style={{\n    display: \'block\',\n    fontSize: \'50px\',\n    color: cookieRunCiColorMain,\n  }}\n/>\n<CookieRunCi\n  style={{\n    display: \'block\',\n    fontSize: \'50px\',\n    color: cookieRunCiColorSub,\n  }}\n/>\n<CookieRunCi\n  style={{\n    display: \'block\',\n    fontSize: \'50px\',\n    color: cookieRunCiColorMain,\n  }}\n  devsisters={{\n    color: devsistersCiColorCoolGray,\n  }}\n/>'} __scope={{props: this ? this.props : props,devsistersCiColorBrightOrange,devsistersCiColorBlack,devsistersCiColorCoolGray,devsistersCiColorWarmGray,cookieRunCiColorMain,cookieRunCiColorSub,DevsistersCi,CookieRunCi,DevsistersBranchCi,BranchCiJapan,BranchCiTaiwan,BranchCiMars,BranchCiStun,BranchCiConnectier,BranchCiVentures,JellyPopGamesCi,OrumlabsCi,RubycuveCi,MakersGamesCi}}>
  <CookieRunCi style={{
    display: 'block',
    fontSize: '50px',
    color: cookieRunCiColorMain,
  }}/>
  <CookieRunCi style={{
    display: 'block',
    fontSize: '50px',
    color: cookieRunCiColorSub,
  }}/>
  <CookieRunCi
    style={{
      display: 'block',
      fontSize: '50px',
      color: cookieRunCiColorMain,
    }}
    devsisters={{
      color: devsistersCiColorCoolGray,
    }}
  />
</Playground>
<MDXTag name="h2" components={components} props={{"id":"devsistersbranchci-branchci"}}>{`DevsistersBranchCi, BranchCi*`}</MDXTag>
<MDXTag name="p" components={components}>{`지사의 CI입니다.`}</MDXTag>

<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-tsx"}}>{`import {
  DevsistersBranchCi,
  BranchCiJapan,
  BranchCiTaiwan,
  BranchCiMars,
  BranchCiStun,
  BranchCiConnectier,
  BranchCiVentures,
} from '@devsisters/ui-common';
// 또는 ... from '@devsisters/ui/lib/common/identity';
`}</MDXTag></MDXTag>
<MDXTag name="h3" components={components} props={{"id":"놀이터-2"}}>{`놀이터`}</MDXTag>
<Playground __position={2} __code={'<DevsistersBranchCi\n  style={{\n    fontSize: \'50px\',\n    color: devsistersCiColorBrightOrange,\n  }}\n  branch={<BranchCiJapan style={{ color: devsistersCiColorCoolGray }} />}\n  type={1}\n/>\n<DevsistersBranchCi\n  style={{\n    marginLeft: \'10px\',\n    fontSize: \'50px\',\n    color: devsistersCiColorBrightOrange,\n  }}\n  branch={<BranchCiTaiwan style={{ color: devsistersCiColorCoolGray }} />}\n  type={1}\n/>\n<DevsistersBranchCi\n  style={{\n    marginTop: \'20px\',\n    display: \'block\',\n    fontSize: \'25px\',\n    color: devsistersCiColorBrightOrange,\n  }}\n  branch={<BranchCiJapan style={{ color: devsistersCiColorCoolGray }} />}\n  type={2}\n/>\n<DevsistersBranchCi\n  style={{\n    marginTop: \'20px\',\n    display: \'block\',\n    fontSize: \'25px\',\n    color: devsistersCiColorBrightOrange,\n  }}\n  branch={<BranchCiTaiwan style={{ color: devsistersCiColorCoolGray }} />}\n  type={2}\n/>\n<DevsistersBranchCi\n  style={{\n    marginTop: \'20px\',\n    fontSize: \'50px\',\n    color: devsistersCiColorBrightOrange,\n  }}\n  branch={<BranchCiMars style={{ color: devsistersCiColorCoolGray }} />}\n  type={1}\n/>\n<DevsistersBranchCi\n  style={{\n    marginLeft: \'10px\',\n    fontSize: \'50px\',\n    color: devsistersCiColorBrightOrange,\n  }}\n  branch={<BranchCiStun style={{ color: devsistersCiColorCoolGray }} />}\n  type={1}\n/>\n<DevsistersBranchCi\n  style={{\n    marginLeft: \'10px\',\n    fontSize: \'50px\',\n    color: devsistersCiColorBrightOrange,\n  }}\n  branch={<BranchCiConnectier style={{ color: devsistersCiColorCoolGray }} />}\n  type={1}\n/>\n<DevsistersBranchCi\n  style={{\n    marginTop: \'20px\',\n    fontSize: \'50px\',\n    color: devsistersCiColorBrightOrange,\n  }}\n  branch={<BranchCiVentures />}\n  type={1}\n/>'} __scope={{props: this ? this.props : props,devsistersCiColorBrightOrange,devsistersCiColorBlack,devsistersCiColorCoolGray,devsistersCiColorWarmGray,cookieRunCiColorMain,cookieRunCiColorSub,DevsistersCi,CookieRunCi,DevsistersBranchCi,BranchCiJapan,BranchCiTaiwan,BranchCiMars,BranchCiStun,BranchCiConnectier,BranchCiVentures,JellyPopGamesCi,OrumlabsCi,RubycuveCi,MakersGamesCi}}>
  <DevsistersBranchCi
    style={{
      fontSize: '50px',
      color: devsistersCiColorBrightOrange,
    }}
    branch={<BranchCiJapan style={{ color: devsistersCiColorCoolGray }}/>}
    type={1}
  />
  <DevsistersBranchCi
    style={{
      marginLeft: '10px',
      fontSize: '50px',
      color: devsistersCiColorBrightOrange,
    }}
    branch={<BranchCiTaiwan style={{ color: devsistersCiColorCoolGray }}/>}
    type={1}
  />
  <DevsistersBranchCi
    style={{
      marginTop: '20px',
      display: 'block',
      fontSize: '25px',
      color: devsistersCiColorBrightOrange,
    }}
    branch={<BranchCiJapan style={{ color: devsistersCiColorCoolGray }}/>}
    type={2}
  />
  <DevsistersBranchCi
    style={{
      marginTop: '20px',
      display: 'block',
      fontSize: '25px',
      color: devsistersCiColorBrightOrange,
    }}
    branch={<BranchCiTaiwan style={{ color: devsistersCiColorCoolGray }}/>}
    type={2}
  />
  <DevsistersBranchCi
    style={{
      marginTop: '20px',
      fontSize: '50px',
      color: devsistersCiColorBrightOrange,
    }}
    branch={<BranchCiMars style={{ color: devsistersCiColorCoolGray }}/>}
    type={1}
  />
  <DevsistersBranchCi
    style={{
      marginLeft: '10px',
      fontSize: '50px',
      color: devsistersCiColorBrightOrange,
    }}
    branch={<BranchCiStun style={{ color: devsistersCiColorCoolGray }}/>}
    type={1}
  />
  <DevsistersBranchCi
    style={{
      marginLeft: '10px',
      fontSize: '50px',
      color: devsistersCiColorBrightOrange,
    }}
    branch={<BranchCiConnectier style={{ color: devsistersCiColorCoolGray }}/>}
    type={1}
  />
  <DevsistersBranchCi
    style={{
      marginTop: '20px',
      fontSize: '50px',
      color: devsistersCiColorBrightOrange,
    }}
    branch={<BranchCiVentures/>}
    type={1}
  />
</Playground>
<MDXTag name="h2" components={components} props={{"id":"jellypopgamesci-orumlabsci-rubycuveci-makersgamesci"}}>{`JellyPopGamesCi, OrumlabsCi, RubycuveCi, MakersGamesCi`}</MDXTag>
<MDXTag name="p" components={components}>{`자회사의 CI입니다.`}</MDXTag>

<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-tsx"}}>{`import {
  JellyPopGamesCi,
  OrumlabsCi,
  RubycuveCi,
  MakersGamesCi,
} from '@devsisters/ui-common';
// 또는 ... from '@devsisters/ui/lib/common/identity';
`}</MDXTag></MDXTag>
<MDXTag name="h3" components={components} props={{"id":"놀이터-3"}}>{`놀이터`}</MDXTag>
<Playground __position={3} __code={'<JellyPopGamesCi\n  style={{\n    display: \'block\',\n    fontSize: \'25px\',\n  }}\n/>\n<OrumlabsCi\n  style={{\n    marginTop: \'20px\',\n    display: \'block\',\n    fontSize: \'50px\',\n  }}\n/>\n<RubycuveCi\n  style={{\n    marginTop: \'20px\',\n    display: \'block\',\n    fontSize: \'40px\',\n  }}\n/>\n<MakersGamesCi\n  style={{\n    marginTop: \'20px\',\n    display: \'block\',\n    fontSize: \'40px\',\n  }}\n/>'} __scope={{props: this ? this.props : props,devsistersCiColorBrightOrange,devsistersCiColorBlack,devsistersCiColorCoolGray,devsistersCiColorWarmGray,cookieRunCiColorMain,cookieRunCiColorSub,DevsistersCi,CookieRunCi,DevsistersBranchCi,BranchCiJapan,BranchCiTaiwan,BranchCiMars,BranchCiStun,BranchCiConnectier,BranchCiVentures,JellyPopGamesCi,OrumlabsCi,RubycuveCi,MakersGamesCi}}>
  <JellyPopGamesCi style={{
    display: 'block',
    fontSize: '25px',
  }}/>
  <OrumlabsCi style={{
    marginTop: '20px',
    display: 'block',
    fontSize: '50px',
  }}/>
  <RubycuveCi style={{
    marginTop: '20px',
    display: 'block',
    fontSize: '40px',
  }}/>
  <MakersGamesCi style={{
    marginTop: '20px',
    display: 'block',
    fontSize: '40px',
  }}/>
</Playground>
           </MDXTag>
  }
}
  